import { useMutation, useQueryClient } from '@tanstack/react-query';

import { PERSONAL_EXPENSES_KEY } from './constants';
import { deletePersonalExpense } from './personalExpenses';

export const useDeletePersonalExpense = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deletePersonalExpense(id),
    onSuccess: async (_, deletedId) => {
      console.debug('Deleted personal expense with id:', deletedId);
      await queryClient.cancelQueries({
        queryKey: [PERSONAL_EXPENSES_KEY, deletedId],
      });
      queryClient.setQueryData([PERSONAL_EXPENSES_KEY, deletedId], null);

      // Invalidate the general collection (enable when we have list queries)
      // queryClient.invalidateQueries({ queryKey: [PERSONAL_EXPENSES_KEY] });
    },
  });
};
